const ColorCookieManCellView = BaseCellView.extend({
    ctor: function (colorcookiemancell) {
        this._super();

        this.setContentSize(cleverapps.styles.BaseCellView.CELL_SIZE_PX, cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        this.setAnchorPoint(0.5, 0.5);

        if (colorcookiemancell.findComponent(ColorComponent).color !== undefined) {
            this.animation = new cleverapps.Spine(bundles.colorcookieman.jsons.color_cookieman_spine_json);
            this.animation.setPosition(this.width / 2, this.height / 2);
            this.addChild(this.animation);
        }

        this.setCascadeOpacityEnabled(true);

        this.initialize(colorcookiemancell);
    },

    getSkin: function (colorcookiemancell) {
        const colors = {
            "a": "blue",
            "b": "green",
            "c": "purple",
            "d": "red",
            "e": "yellow",
            "w": "white"
        };

        return colors[colorcookiemancell.findComponent(ColorComponent).color];
    },

    initialize: function (colorcookiemancell) {
        this._super(colorcookiemancell);

        colorcookiemancell.onBeforeExplodeListener = this.createListener(this.startExplodingViaCollect.bind(this));
        colorcookiemancell.onFinishMoveListener = this.createListener(this.cookieManFinishMoving.bind(this));

        const colorComponent = colorcookiemancell.findComponent(ColorComponent);
        colorComponent.view.show();

        if (this.animation) {
            this.animation.setSkin(this.getSkin(colorcookiemancell));
            this.animation.setVisible(false);
        }

        this.smiling = false;
        this.setVisible(colorcookiemancell.visible);
    },

    cookieManFinishMoving: function (destination, options, onFinishCallback) {
        this.finishMoving(destination, options, onFinishCallback);
        this.finishSmile();
    },

    swapImageToAnimation: function () {
        this.runAction(new cc.CallFunc(() => {
            const colorComponent = this.cell.findComponent(ColorComponent);
            colorComponent.view.hide();

            this.animation.visible = true;
        }));
    },

    finishSmile: function () {
        if (this.smiling) {
            this.smiling = false;

            const colorComponent = this.cell.findComponent(ColorComponent);
            colorComponent.view.show();

            this.animation.visible = false;
        }
    },

    smile: function () {
        if (!this.animation) {
            return;
        }

        if (this.smiling) {
            return;
        }
        this.smiling = true;
        this.animation.setAnimation(0, "animation", false);
        this.animation.setCompleteListener(this.finishSmile.bind(this));
        this.swapImageToAnimation();
        if (bundles.colorcookieman.urls.clown_smile_effect) {
            cleverapps.effects.fire("colorcookieman.smile");
        }
    },

    startExplodingViaCollect: function () {
        if (bundles.colorcookieman.urls.clown_collect_effect) {
            cleverapps.effects.fire("colorcookieman.collect");
        }

        // eslint-disable-next-line prefer-spread,prefer-rest-params
        this._super.apply(this, arguments);
    },

    cookieUp: function (callback) {
        callback = callback || function () {};
        const initialZOrder = this.getLocalZOrder();
        if (this.animation) {
            this.setLocalZOrder(3);
            this.smiling = true;
            this.animation.setAnimation(0, "up", false);
            this.animation.setCompleteListener(() => {
                callback();
                this.finishSmile();
                this.setLocalZOrder(initialZOrder);
            });
            this.swapImageToAnimation();
        } else {
            this.setLocalZOrder(3);
            const position = BaseCellView.alignInTheGrid(this.cell.x, this.cell.y);
            this.runAction(new cc.Sequence(
                new cc.DelayTime(0.3),
                new cc.MoveTo(0.5, position),
                new cc.CallFunc(() => {
                    this.setLocalZOrder(initialZOrder);
                    callback();
                })
            ));
        }
        if (bundles.colorcookieman.urls.clown_jump_effect) {
            cleverapps.effects.fire("colorcookieman.jump");
        }
    },

    cookieIn: function (callback) {
        callback = callback || function () {};
        cleverapps.effects.fire("colorcookieman.cookie.in");
        if (this.animation) {
            this.smiling = true;
            this.animation.setAnimation(0, "in", false);
            this.animation.setCompleteListener(() => {
                callback();
                this.finishSmile();
            });
            this.swapImageToAnimation();
        } else {
            this.setScale(0);
            this.runAction(new cc.Sequence(
                new cc.Spawn(new cc.RotateBy(1, 360 * 2), new cc.ScaleTo(1, 1)),
                new cc.CallFunc(callback)
            ));
        }
    },

    cookieOut: function (callback) {
        callback = callback || function () {};
        cleverapps.effects.fire("colorcookieman.cookie.out");
        if (this.animation) {
            this.smiling = true;
            this.animation.setAnimation(0, "out", false);
            this.animation.setCompleteListener(() => {
                callback();
                this.finishSmile();
                this.setVisible(false);
            });
            this.swapImageToAnimation();
        } else {
            this.runAction(new cc.Sequence(
                new cc.Spawn(new cc.RotateBy(1, -360 * 2), new cc.ScaleTo(1, 0)),
                new cc.CallFunc(callback)
            ));
        }
    }
});